export default "__VITE_ASSET__C$gQfyWg__"